/* Breaking news rolling list
   Reads a JSON feed ({updated, items:[{id,title,url,source,region,published}]})
   and keeps a fixed-length list that rolls: new items enter at the top,
   the oldest drop off the bottom. */
(function () {
    const root = document.querySelector('[data-breaking-news]');
    if (!root) return;

    const feedUrl = root.dataset.feed;
    const limit = Math.max(1, parseInt(root.dataset.limit, 10) || 6);
    const refreshMs = Math.max(30, parseInt(root.dataset.refresh, 10) || 60) * 1000;
    const page = (root.dataset.page || '').toLowerCase();
    const list = root.querySelector('[data-breaking-list]');
    const updatedEl = root.querySelector('[data-breaking-updated]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let seen = new Map();   // id -> <li>
    let firstRender = true;
    let lastUpdated = null;
    let timer = null;

    function ago(iso) {
        const t = Date.parse(iso);
        if (isNaN(t)) return '';
        const s = Math.max(0, Math.round((Date.now() - t) / 1000));
        if (s < 60) return 'now';
        const m = Math.round(s / 60);
        if (m < 60) return m + 'm ago';
        const h = Math.round(m / 60);
        if (h < 24) return h + 'h ago';
        return Math.round(h / 24) + 'd ago';
    }

    function safeUrl(u) {
        try {
            const url = new URL(u, window.location.href);
            return /^https?:$/.test(url.protocol) ? url.href : null;
        } catch (e) { return null; }
    }

    function build(item) {
        const li = document.createElement('li');
        li.className = 'gh-breaking-item';
        li.dataset.id = item.id;
        li.dataset.published = item.published || '';

        const time = document.createElement('time');
        time.className = 'gh-breaking-time';
        time.dateTime = item.published || '';
        time.textContent = ago(item.published);
        li.appendChild(time);

        if (item.region) {
            const r = document.createElement('span');
            r.className = 'gh-breaking-region';
            r.textContent = item.region;
            li.appendChild(r);
        }

        const href = safeUrl(item.url);
        const head = document.createElement(href ? 'a' : 'span');
        head.className = 'gh-breaking-headline';
        head.textContent = item.title;
        if (href) {
            head.href = href;
            head.target = '_blank';
            head.rel = 'noopener noreferrer';
        }
        li.appendChild(head);

        if (item.source) {
            const s = document.createElement('span');
            s.className = 'gh-breaking-source';
            s.textContent = item.source;
            li.appendChild(s);
        }
        return li;
    }

    function render(data) {
        const items = (data && Array.isArray(data.items) ? data.items : [])
            .filter(function (i) { return i && i.id && i.title; })
            .filter(function (i) { return !page || (Array.isArray(i.pages) && i.pages.indexOf(page) !== -1); })
            .sort(function (a, b) { return Date.parse(b.published) - Date.parse(a.published); })
            .slice(0, limit);

        if (!items.length) { root.hidden = true; return; }
        root.hidden = false;

        const wanted = new Set(items.map(function (i) { return String(i.id); }));

        // drop items that rolled off
        seen.forEach(function (li, id) {
            if (!wanted.has(id)) {
                seen.delete(id);
                if (reduceMotion || firstRender) { li.remove(); return; }
                li.classList.add('is-leaving');
                setTimeout(function () { li.remove(); }, 400);
            }
        });

        // add new items, keeping order (newest first)
        let prev = null;
        items.forEach(function (item) {
            const id = String(item.id);
            let li = seen.get(id);
            if (!li) {
                li = build(item);
                if (!firstRender && !reduceMotion) li.classList.add('is-new');
                seen.set(id, li);
            }
            const expected = prev ? prev.nextSibling : list.firstChild;
            if (li !== expected) list.insertBefore(li, expected);
            prev = li;
        });

        firstRender = false;
        if (data.updated) lastUpdated = data.updated;
        tick();
    }

    function tick() {
        list.querySelectorAll('.gh-breaking-item').forEach(function (li) {
            const t = li.querySelector('.gh-breaking-time');
            if (t) t.textContent = ago(li.dataset.published);
        });
        if (updatedEl && lastUpdated) updatedEl.textContent = 'Updated ' + ago(lastUpdated);
    }

    function load() {
        fetch(feedUrl, { cache: 'no-store', credentials: 'omit' })
            .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
            .then(render)
            .catch(function () { /* keep whatever is on screen; try again next cycle */ });
    }

    function start() {
        load();
        timer = setInterval(load, refreshMs);
    }

    document.addEventListener('visibilitychange', function () {
        if (document.hidden) { clearInterval(timer); timer = null; }
        else if (!timer) { start(); }
    });

    setInterval(tick, 30000);
    start();
})();
